module.exports = __webpack_public_path__ + "img/banner.fed978da.png";